export const APP_ROOT_ID = 'header-root';
export const MB_EVENT_HAMBURGER_CLICKED = 'wh.header.event.hamburger.clicked';
export const HEADER_PROPS_UPDATE_REQUESTED = 'wh.header.piHeaderPropsUpdate.requested';
export const HEADER_BASE_CONFIG = {
  actions: {
    type: '@sitebase/action-area',
    data: {
      id: 'hrs-action-area',
    },
    children: [],
  },
};
